// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".buttonContainer[data-v-27c5d369]{display:flex;flex-direction:column;align-items:center;width:100%}.button[data-v-27c5d369]{transform:translate(-230%)}@media(max-width:768px){.button[data-v-27c5d369]{transform:translate(-200%)}}@media(max-width:481px){.button[data-v-27c5d369]{transform:translate(-180%)}}", ""]);
// Exports
module.exports = exports;
